<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="订单状态" prop="masterOrderStatus">
                <a-select v-model="queryParam.masterOrderStatus" allow-clear placeholder="请选择订单状态">
                  <a-select-option value="-1">待支付</a-select-option>
                  <a-select-option value="0">接单中</a-select-option>
                  <a-select-option value="1">待服务</a-select-option>
                  <a-select-option value="2">服务中</a-select-option>
                  <a-select-option value="3">待评价</a-select-option>
                  <a-select-option value="4">已完成</a-select-option>
                  <a-select-option value="5">售后中</a-select-option>
                  <a-select-option value="6">售后完成</a-select-option>
                  <a-select-option value="7">已关闭</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="售后状态" prop="aftermarketStatus">
                <a-select v-model="queryParam.aftermarketStatus" allow-clear placeholder="请选择订单售后状态">
                  <a-select-option value="0">无需售后</a-select-option>
                  <a-select-option value="1">待联系客户</a-select-option>
                  <a-select-option value="2">待售后完成</a-select-option>
                  <a-select-option value="3">已提交售后</a-select-option>
                  <a-select-option value="4">售后完成</a-select-option>
                  <a-select-option value="5">平台审核</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="客户订单编号" prop="customerOrderId">
                  <a-input v-model="queryParam.customerOrderId" allow-clear placeholder="请输入客户订单编号"/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
                <a style="margin-left: 8px" @click="toggleAdvanced">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button v-hasPermi="['master:order:remove']" :disabled="multiple" type="danger" @click="handleDelete">
          <a-icon type="delete"/>
          删除
        </a-button>
        <a-button v-hasPermi="['master:order:export']" type="primary" @click="handleExport">
          <a-icon type="download"/>
          导出
        </a-button>
        <table-setting
          v-model="columns"
          :refresh-loading="loading"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          @refresh="getList"/>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :bordered="tableBordered"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: 1330 }"
        :size="tableSize"
        rowKey="id"
      >
        <span slot="masterOrderStatus" slot-scope="text, record">
          <a-tag v-if="record.masterOrderStatus === -1" color="gold">待支付</a-tag>
          <a-tag v-else-if="record.masterOrderStatus === 0" color="blue">接单中</a-tag>
          <a-tag v-else-if="record.masterOrderStatus === 1" color="orange">待服务</a-tag>
          <a-tag v-else-if="record.masterOrderStatus === 2" color="cyan">服务中</a-tag>
          <a-tag v-else-if="record.masterOrderStatus === 3" color="purple">待评价</a-tag>
          <a-tag v-else-if="record.masterOrderStatus === 4" color="green">已完成</a-tag>
          <a-tag v-else-if="record.masterOrderStatus === 5" color="volcano">售后中</a-tag>
          <a-tag v-else-if="record.masterOrderStatus === 6" color="lime">售后完成</a-tag>
          <a-tag v-else-if="record.masterOrderStatus === 7" color="geekblue">已关闭</a-tag>
          <span v-else>{{ record.masterOrderStatus }}</span>
        </span>
        <span slot="aftermarketStatus" slot-scope="text, record">
          <a-tag v-if="record.aftermarketStatus === 0" color="blue">无需售后</a-tag>
          <a-tag v-else-if="record.aftermarketStatus === 1" color="orange">待联系客户</a-tag>
          <a-tag v-else-if="record.aftermarketStatus === 2" color="gold">待售后完成</a-tag>
          <a-tag v-else-if="record.aftermarketStatus === 3" color="blue">已提交售后</a-tag>
          <a-tag v-else-if="record.aftermarketStatus === 4" color="green">售后完成</a-tag>
          <a-tag v-else-if="record.aftermarketStatus === 5" color="purple">平台审核</a-tag>
          <span v-else>{{ record.aftermarketStatus }}</span>
        </span>
        <span slot="orderUnitPrice" slot-scope="text, record">
          {{ record.orderUnitPrice != null ? '¥' + Number(record.orderUnitPrice).toFixed(2) : '-' }}
        </span>
        <span slot="orderTotalPrice" slot-scope="text, record">
          {{ record.orderTotalPrice != null ? '¥' + Number(record.orderTotalPrice).toFixed(2) : '-' }}
        </span>
        <span slot="bondPrice" slot-scope="text, record">
          {{ record.bondPrice != null ? '¥' + Number(record.bondPrice).toFixed(2) : '-' }}
        </span>
        <span slot="bondPayType" slot-scope="text, record">
          <a-tag v-if="record.bondPayType === 1" color="green">微信</a-tag>
          <a-tag v-else-if="record.bondPayType === 2" color="blue">支付宝</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="bondPayStatus" slot-scope="text, record">
          <a-tag v-if="record.bondPayStatus === 0" color="blue">不需支付</a-tag>
          <a-tag v-else-if="record.bondPayStatus === 1" color="orange">待支付</a-tag>
          <a-tag v-else-if="record.bondPayStatus === 2" color="green">已支付</a-tag>
          <a-tag v-else-if="record.bondPayStatus === 3" color="red">已取消</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="quotationTime" slot-scope="text, record">
          {{ parseTime(record.quotationTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="eye" />查看
          </a>
          <a-divider v-hasPermi="['master:order:remove']" type="vertical"/>
          <a v-hasPermi="['master:order:remove']" @click="handleDelete(record)">
            <a-icon type="delete"/>删除
          </a>
          <a-divider v-if="record.aftermarketStatus === 5" v-hasPermi="['master:order:remove']" type="vertical"/>
          <a v-if="record.aftermarketStatus === 5" v-hasPermi="['master:order:remove']" @click="handleDelete(record)">
            <a-icon type="delete"/>完成售后
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        :current="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        :total="total"
        class="ant-table-pagination"
        show-quick-jumper
        show-size-changer
        @change="changeSize"
        @showSizeChange="onShowSizeChange"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delOrder, pageOrder } from '@/api/master/order'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Order',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        customerOrderId: null,
        masterOrderStatus: undefined,
        aftermarketStatus: undefined,
        aftermarketNum: null,
        orderUnitPrice: null,
        orderTotalPrice: null,
        quotationPrice: null,
        quotationTime: null,
        bondPrice: null,
        bondPayType: null,
        bondPayStatus: null,
        startCode: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '师傅名称',
          dataIndex: 'userName',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          align: 'center',
          width: 180,
          ellipsis: true
        },
        {
          title: '订单状态',
          dataIndex: 'masterOrderStatus',
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'masterOrderStatus' }
        },
        {
          title: '售后状态',
          dataIndex: 'aftermarketStatus',
          align: 'center',
          width: 110,
          scopedSlots: { customRender: 'aftermarketStatus' }
        },
        {
          title: '售后次数',
          dataIndex: 'aftermarketNum',
          width: 90,
          align: 'center'
        },
        {
          title: '订单单价',
          dataIndex: 'orderUnitPrice',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'orderUnitPrice' }
        },
        {
          title: '订单总价',
          dataIndex: 'orderTotalPrice',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'orderTotalPrice' }
        },
        {
          title: '保证金金额',
          dataIndex: 'bondPrice',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'bondPrice' }
        },
        {
          title: '保证金支付类型',
          dataIndex: 'bondPayType',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'bondPayType' }
        },
        {
          title: '保证金支付状态',
          dataIndex: 'bondPayStatus',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'bondPayStatus' }
        },
        {
          title: '开工码',
          dataIndex: 'startCode',
          width: 90,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 140,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询师傅订单列表 */
    getList() {
      this.loading = true
      pageOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        customerOrderId: undefined,
        masterOrderStatus: undefined,
        aftermarketStatus: undefined,
        aftermarketNum: undefined,
        orderUnitPrice: undefined,
        orderTotalPrice: undefined,
        quotationPrice: undefined,
        quotationTime: undefined,
        bondPrice: undefined,
        bondPayType: undefined,
        bondPayStatus: undefined,
        startCode: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = []
          that.ids.map(id => data.push({ id: id }))
          return delOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('master/master-order/export', {
            ...that.queryParam
          }, `师傅订单_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
